export default class classVeryCheckbox {
  static getPropsTemplate = () => ({
    CSS: [""],
    isDisabled: false,
    isLoading: false,
    selected: false,
    onChangeSelected: (toggleSelected = false) => {},
  });
}
